import ModulObjektlisteElementList from "../../../Generics/ModulObjektlisteElementList/ModulObjektlisteElementList.vue";
import ModuleMixin from "../ModuleMixin";

// @vue/component
export default {
  name: "Objektliste",
  components: {
    ModulObjektlisteElementList,
  },
  mixins: [
    ModuleMixin,
  ],
  computed: {
    labelHeader() {
      if (this.modelParameter.titel) {
        return this.modelParameter.titel;
      }
      return "_TXT_GR_OBJEKTLISTE_";
    },

    isModuleEditable() {
      return false;
    },
  },
};
